import { render, staticRenderFns } from "./importRequests.vue?vue&type=template&id=04f82d90&"
import script from "./importRequests.vue?vue&type=script&lang=js&"
export * from "./importRequests.vue?vue&type=script&lang=js&"
import style0 from "./importRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports